import React from "react";
import {
  Box,
  Button,
  Flex,
  Skeleton,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  Ellipsis,
  Eye,
  Paperclip,
} from "lucide-react";

import ThreeDotMenu from "components/Menus/ThreeDotMenu";
import StatusBadge, {
  getStatusVariant,
} from "components/Badges/StatusBadge";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const buildAttachmentUrl = (path) => {
  if (!path) return null;

  return `${BASE_URL.replace(/\/$/, "")}/${String(path).replace(/^\/+/, "")}`;
};

const DriverPartnerSupportCard = ({
  subject,
  first_name,
  last_name,
  email,
  phone_number,
  status,
  message,
  attachments = [],
  created_at,
  loading,
  onView,
}) => {
  const cardBg = useColorModeValue("gray.100", "gray.700");

  const textColor = useColorModeValue("gray.500", "white");

  const menuItems = [
    {
      icon: <Eye size={16} />,
      text: "View Ticket",
      onClick: onView,
    },
  ];
  const fullName = [first_name, last_name]
  .filter(Boolean)
  .join(" ")
  .trim();

  const imageAttachment = attachments.find((attachment) => {
    const file =
      attachment?.file_url ||
      attachment?.file_path ||
      attachment?.url ||
      attachment;

    return (
      typeof file === "string" &&
      /\.(jpg|jpeg|png|gif|webp)$/i.test(file)
    );
  });

  const imageUrl = imageAttachment
    ? buildAttachmentUrl(
        imageAttachment.file_url ||
          imageAttachment.file_path ||
          imageAttachment.url ||
          imageAttachment
      )
    : null;

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p={6}
      boxShadow="md"
      maxW="sm"
      bg={cardBg}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        {loading ? (
          <Skeleton
            height="20px"
            width="90px"
          />
        ) : (
            <StatusBadge
                label={status.replace(/_/g, " ")}
                variant={getStatusVariant(status)}
            />
        )}

        {loading ? (
          <Skeleton
            height="20px"
            width="20px"
            borderRadius="50%"
          />
        ) : (
          <ThreeDotMenu
            icon={
              <Ellipsis
                size={20}
                color="grey"
              />
            }
            items={menuItems}
          />
        )}
      </Flex>

    <Flex
        justifyContent="center"
        mt={5}
        mb={4}
        >
        {loading ? (
          <Skeleton
            height="150px"
            width="100%"
            borderRadius="8px"
          />
        ) : imageUrl ? (
          <img
            src={imageUrl}
            alt={subject}
            style={{
              borderRadius: "8px",
              width: "100%",
              maxHeight: "150px",
              objectFit: "cover",
            }}
          />
        ) : (
          <Skeleton
            height="150px"
            width="100%"
            borderRadius="8px"
          />
        )}
      </Flex>

      <Box>
        {loading ? (
          <>
            <Skeleton
              height="22px"
              mb={3}
            />
            <Skeleton
              height="14px"
              width="120px"
              mb={4}
            />
            <Skeleton
              height="16px"
              mb={2}
            />
            <Skeleton
              height="16px"
              width="90%"
            />
          </>
        ) : (
          <>
            <Text
              fontWeight="bold"
              fontSize="lg"
              color="#071D54"
              noOfLines={2}
              mb={2}
            >
              {subject}
            </Text>

            <Text
              fontSize="xs"
              color="gray.500"
              fontWeight="600"
            >
              Submitted By
            </Text>

            <Text
              fontSize="sm"
              color="gray.700"
              mb={4}
            >
              {fullName || "Unknown User"}
            </Text>

            <Text
              fontSize="sm"
              color="gray.600"
              noOfLines={1}
            >
              {message}
            </Text>
          </>
        )}
      </Box>

      <Flex
        justifyContent="space-between"
        alignItems="center"
        mt={6}
      >
        <Flex
          direction="column"
          gap={1}
        >
          {loading ? (
            <>
              <Skeleton
                width="90px"
                height="14px"
              />
              <Skeleton
                width="120px"
                height="14px"
              />
            </>
          ) : (
            <>
              <Text
                fontSize="xs"
                color={textColor}
              >
                {created_at
                  ? new Date(created_at).toLocaleDateString()
                  : "N/A"}
              </Text>

              <Flex
                align="center"
                gap={1}
              >
                <Paperclip size={13} />

                <Text
                  fontSize="xs"
                  color={textColor}
                >
                  {attachments.length} Attachment
                  {attachments.length !== 1 ? "s" : ""}
                </Text>
              </Flex>
            </>
          )}
        </Flex>

        {loading ? (
          <Skeleton
            width="90px"
            height="18px"
          />
        ) : (
          <Button
            variant="link"
            color="#071D54"
            fontSize="xs"
            onClick={onView}
          >
            View Ticket {">"}
          </Button>
        )}
      </Flex>
    </Box>
  );
};

export default DriverPartnerSupportCard;